module.exports = __webpack_public_path__ + "static/media/electricitytransmission.58956218.jpg";